var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#8A99BB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343.38-160v-30.77h121.24v-161.08q-54.77-9.46-96-46.5-41.24-37.03-55.7-91.57-63.23-7.23-108.07-49.62Q160-581.92 160-643.38v-42.47q0-11.92 9.04-21.34 9.04-9.43 21.73-9.43h117.08V-800h344.3v83.38h117.08q12.69 0 21.73 9.43 9.04 9.42 9.04 21.34v42.47q0 61.46-44.85 103.84-44.84 42.39-108.07 49.62-14.46 54.54-55.7 91.57-41.23 37.04-96 46.5v161.08h121.24V-160H343.38Zm-35.53-362.15v-163.7H190.77v42.47q0 48.07 34.11 82.34 34.12 34.27 82.97 38.89Zm271.34 98.69q40.66-40.77 40.66-99.31v-246.46h-279.7v246.46q0 58.54 40.66 99.31 40.65 40.77 99.19 40.77t99.19-40.77Zm72.96-98.69q48.85-4.62 82.97-38.89 34.11-34.27 34.11-82.34v-42.47H652.15v163.7ZM480-576.08Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.a18f3475.svg";
export { ForwardRef as ReactComponent };